import React from "react";
import p500 from '../images/500.png'
import {useHistory} from "react-router-dom";


function Page500(){

    const { replace } = useHistory()

    return <div className="p500">
        <img src={ p500 } alt=""/>
        <p>系统当前无法提供服务，请重试</p>
        <div className="btn" onClick={ () => replace('/') }>重试</div>
    </div>
}

export default Page500
